module.exports = __webpack_public_path__ + "images/Group 1260b7898625b151cb894b2ebcdb4464043d.svg";